import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { STATUS } from "..";
import { useMutation, useQuery } from "react-query";
import {
    _api_approve_or_reject_timesheet,
    _api_externe_validation_leave,
} from "../api";

const useLogicManagerValidationLeaveRequest = () => {
    const { hash } = useParams();
    const [status, setStatus] = useState(STATUS.approve);

    const { data, isLoading, isError } = useQuery(
        ["MANAGER_VALIDATION_LEAVE_REQUEST"],
        () => {
            return _api_externe_validation_leave(hash);
        },
        {
            retry: false,
            refetchOnWindowFocus: false,
        }
    );

    const {
        mutate,
        isLoading: isLoadingMutate,
        data: mutate_data,
    } = useMutation((step) => _api_approve_or_reject_timesheet({ step, hash }));

    const _validate_or_not_request_leave = (status) => {
        return mutate(status);
    };

    return {
        states: {
            status,
            setStatus,
        },
        query: {
            data,
            isLoading,
            isError,
        },
        mutation: {
            mutate,
            isLoadingMutate,
            mutate_data,
        },
        functions: {
            _validate_or_not_request_leave,
        },
    };
};

export default useLogicManagerValidationLeaveRequest;
